import Select, { SelectProps } from 'antd/lib/select';
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { getParList } from '../../../services/parametersService';
import { Input } from 'antd';

export type ParListSelectProps = SelectProps<any> & {
  parcode: string;
  ParcodeParent?: string;
  forcedValue?: string;
  onChange?: any;
};

const ParListByParcodeSelect = ({
  parcode,
  ParcodeParent,
  forcedValue,
  onChange,
  ...props
}: ParListSelectProps) => {
  useEffect(() => {
    if (forcedValue) {
      onChange(forcedValue ?? '');
    }
  }, [forcedValue]);

  const { data } = useQuery(
    ['ParList', { parcode }],
    () => getParList({ parcode, tpid: 0 }).then((res) => res.list || []),
    {
      staleTime: MINUTE,
      enabled: !!parcode,
    }
  );
  return ParcodeParent ? (
    <Input value={ParcodeParent} disabled />
  ) : (
    <Select
      {...props}
      showSearch
      filterOption={(input, option) =>
        option?.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      allowClear
      onChange={(e) => {
        onChange && onChange(e);
      }}
    >
      {data?.map((role) => (
        <Select.Option value={role.parvalue} key={role.id}>
          {role.parlistlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ParListByParcodeSelect;
